import React from 'react';
import { REPORT } from '../print/PrintAtoms';
import { PORTFOLIO_TOKENS } from './tokens';

const headStyle: React.CSSProperties = {
  fontFamily: PORTFOLIO_TOKENS.mono,
  fontSize: 8.5,
  fontWeight: 600,
  letterSpacing: '0.10em',
  textTransform: 'uppercase',
  color: REPORT.tertiary,
};

export const PortfolioColumnHeader: React.FC = () => (
  <div style={{
    display: 'grid',
    gridTemplateColumns: '48px 230px 1fr 392px 150px',
    gap: 14,
    padding: '10px 16px',
    borderBottom: `1px solid ${REPORT.rule}`,
    alignItems: 'center',
    ...headStyle,
  }}>
    <span style={{ textAlign: 'center' }}>#</span>
    <span>Site</span>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', padding: '0 1px' }}>
      <span style={{ padding: '0 11px' }}>Acres</span>
      <span style={{ padding: '0 11px' }}>Pipeline MW</span>
      <span style={{ padding: '0 11px' }}>Air Permit</span>
      <span style={{ padding: '0 11px' }}>Site Risk</span>
    </div>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 5 }}>
      <span>Power</span>
      <span>Land</span>
      <span>Owner</span>
      <span>Fiber</span>
      <span>Water</span>
    </div>
    <span style={{ textAlign: 'right' }}>Resolve · Grade</span>
  </div>
);
